/**
 * Free-look mode cue (HEX-144).
 *
 * Free-look (HEX-96) decouples the camera from the character so the player can
 * survey the map — but it had no on-screen affordance, so playtesters never
 * found it ("followed the compass in circles, couldn't find the next town").
 * This banner appears at the top of the stage whenever free-look is active and
 * spells out how to pan and how to recentre. Pure DOM, schematic chrome to
 * match the other HUD clusters; a faint pulse draws the eye (carved out under
 * `prefers-reduced-motion`, honouring the HEX-96 reduced-motion discipline).
 */
export class FreeLookCue {
  private root: HTMLDivElement | null = null;

  constructor(private readonly container: HTMLElement) {}

  /** Show the cue (idempotent). */
  show(): void {
    if (this.root) return;
    const root = document.createElement('div');
    root.className = 'hex6-freelook-cue';
    root.dataset.role = 'freelook-cue';

    const title = document.createElement('span');
    title.className = 'hex6-freelook-cue__title';
    title.textContent = 'FREE LOOK';

    const hint = document.createElement('span');
    hint.className = 'hex6-freelook-cue__hint';
    hint.textContent = 'drag or arrows to pan · f / Esc to recentre';

    root.append(title, hint);
    this.container.appendChild(root);
    this.root = root;
  }

  /** Hide the cue (idempotent). */
  hide(): void {
    this.root?.remove();
    this.root = null;
  }

  /** Test seam — is the cue currently mounted? */
  isVisible(): boolean {
    return this.root !== null;
  }

  destroy(): void {
    this.hide();
  }
}
